<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    :width="width" :height="height"
    viewBox="0 0 476.06076 117.2107"
    version="1.1"
    id="svg8"
    inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)">
    <defs
      id="defs2">
      <path
        d="M 440.91,449.81 C 483.95,408.7 508.5,347.62 508.5,285.03 508.5,158.73 405.77,56 279.48,56 147.74,56 65.49,153.35 52.41,259.44 76.9,167.29 168.86,98.64 251.47,98.64 c 90.34,0 137.6,41.61 171.35,101.81 14.62,24.77 23.01,53.67 23.01,84.58 0,61.11 -28.4,117.61 -85.69,143.7 l -0.7,0.32 -0.29,0.12 -0.99,0.43 c -10.56,4.52 -29.65,11.92 -38.54,5.6 12.71,32.34 47,47.93 121.29,14.61"
        id="SVGID_1_"
        inkscape:connector-curvature="0" />
      <path
        d="m 72.6,187.89 c -38.8,80.26 -34.01,181.76 41.79,259.53 5.81,7.58 14.98,12.43 25.26,12.37 17.45,-0.1 31.52,-14.32 31.42,-31.78 -0.06,-10.06 -4.82,-19.01 -12.19,-24.76 -119.99,-123.9 7.47,-332.17 174,-275.57 57.88,19.67 97.8,67.87 109.41,123.55 C 429.7,183.36 398.35,128.77 312.81,99.7 234.6,73.12 125.44,108.53 72.6,187.89"
        id="SVGID_00000043457461957744617340000012021026365983084933_"
        inkscape:connector-curvature="0" />
    </defs>
    <sodipodi:namedview
      id="base"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageopacity="0.0"
      inkscape:pageshadow="2"
      inkscape:zoom="0.35"
      inkscape:cx="791.07095"
      inkscape:cy="138.6434"
      inkscape:document-units="mm"
      inkscape:current-layer="layer1"
      showgrid="false"
      fit-margin-top="0"
      fit-margin-left="0"
      fit-margin-right="0"
      fit-margin-bottom="0"
      inkscape:window-width="1920"
      inkscape:window-height="1016"
      inkscape:window-x="1920"
      inkscape:window-y="27"
      inkscape:window-maximized="1" />
    <metadata
      id="metadata5">
      <rdf:RDF>
        <cc:Work
          rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
      inkscape:label="Camada 1"
      inkscape:groupmode="layer"
      id="layer1"
      transform="translate(281.11967,-72.085125)">
      <g
        id="g126"
        transform="matrix(0.26458333,0,0,0.26458333,-294.00889,57.268459)">
        <path
          id="path12"
          d="m 633.66,106.44 c 15.77,0 28.57,12.79 28.57,28.57 0,15.78 -12.8,28.58 -28.57,28.58 -15.79,0 -28.58,-12.8 -28.58,-28.58 0,-15.78 12.79,-28.57 28.58,-28.57"
          class="st0"
          inkscape:connector-curvature="0"
          style="clip-rule:evenodd;fill:#e50520;fill-rule:evenodd" />
        <path
          id="path14"
          d="m 279.73,180.31 c 17.69,0 32.03,14.34 32.03,32.02 0,17.68 -14.34,32.02 -32.03,32.02 -17.68,0 -32.02,-14.34 -32.02,-32.02 0,-17.68 14.34,-32.02 32.02,-32.02"
          class="st1"
          inkscape:connector-curvature="0"
          style="clip-rule:evenodd;fill:#e3022b;fill-rule:evenodd" />
        <g
          id="g37">
    <defs
    id="defs17">
      <path
    d="M 440.91,449.81 C 483.95,408.7 508.5,347.62 508.5,285.03 508.5,158.73 405.77,56 279.48,56 147.74,56 65.49,153.35 52.41,259.44 76.9,167.29 168.86,98.64 251.47,98.64 c 90.34,0 137.6,41.61 171.35,101.81 14.62,24.77 23.01,53.67 23.01,84.58 0,61.11 -28.4,117.61 -85.69,143.7 l -0.7,0.32 -0.29,0.12 -0.99,0.43 c -10.56,4.52 -29.65,11.92 -38.54,5.6 12.71,32.34 47,47.93 121.29,14.61"
    id="path90"
    inkscape:connector-curvature="0" />

    </defs>

    <clipPath
    id="SVGID_00000072988129229812187600000009682045217099230621_">
      <use
    id="use19"
    style="overflow:visible"
    xlink:href="#SVGID_1_"
    x="0"
    y="0"
    width="100%"
    height="100%" />

    </clipPath>

    
      <linearGradient
    y2="465.1431"
    x2="238.79581"
    y1="59.8167"
    x1="325.1366"
    gradientUnits="userSpaceOnUse"
    id="SVGID_00000004523047755154645930000010427647935351967667_">
      <stop
    id="stop22"
    style="stop-color:#E3022B"
    offset="0" />

      <stop
    id="stop24"
    style="stop-color:#DF022A"
    offset="0.1892" />

      <stop
    id="stop26"
    style="stop-color:#D20228"
    offset="0.3922" />

      <stop
    id="stop28"
    style="stop-color:#BC0123"
    offset="0.6016" />

      <stop
    id="stop30"
    style="stop-color:#9F011D"
    offset="0.8139" />

      <stop
    id="stop32"
    style="stop-color:#7E0017"
    offset="1" />

    </linearGradient>

    
      <rect
    id="rect35"
    clip-path="url(#SVGID_00000072988129229812187600000009682045217099230621_)"
    height="427.13"
    width="456.10001"
    style="fill:url(#SVGID_00000004523047755154645930000010427647935351967667_)"
    y="56"
    x="52.41" />

  </g>
        <g
          id="g62">
    <defs
    id="defs40">
      <path
    d="m 72.6,187.89 c -38.8,80.26 -34.01,181.76 41.79,259.53 5.81,7.58 14.98,12.43 25.26,12.37 17.45,-0.1 31.52,-14.32 31.42,-31.78 -0.06,-10.06 -4.82,-19.01 -12.19,-24.76 -119.99,-123.9 7.47,-332.17 174,-275.57 57.88,19.67 97.8,67.87 109.41,123.55 C 429.7,183.36 398.35,128.77 312.81,99.7 234.6,73.12 125.44,108.53 72.6,187.89"
    id="path104"
    inkscape:connector-curvature="0" />

    </defs>

    <clipPath
    id="SVGID_00000172414600649338961390000016094044084568978073_">
      <use
    id="use42"
    style="overflow:visible"
    xlink:href="#SVGID_00000043457461957744617340000012021026365983084933_"
    x="0"
    y="0"
    width="100%"
    height="100%" />

    </clipPath>

    
      <linearGradient
    y2="206.5295"
    x2="410.35641"
    y1="330.22461"
    x1="48.773701"
    gradientUnits="userSpaceOnUse"
    id="SVGID_00000080192896497866294550000002076154367824189827_">
      <stop
    id="stop45"
    style="stop-color:#E3022B"
    offset="0" />

      <stop
    id="stop47"
    style="stop-color:#E0022A"
    offset="0.2157" />

      <stop
    id="stop49"
    style="stop-color:#D50228"
    offset="0.3966" />

      <stop
    id="stop51"
    style="stop-color:#C40125"
    offset="0.565" />

      <stop
    id="stop53"
    style="stop-color:#AB0120"
    offset="0.7257" />

      <stop
    id="stop55"
    style="stop-color:#8C011A"
    offset="0.8797" />

      <stop
    id="stop57"
    style="stop-color:#6E0014"
    offset="1" />

    </linearGradient>

    
      <rect
    id="rect60"
    clip-path="url(#SVGID_00000172414600649338961390000016094044084568978073_)"
    height="388.76999"
    width="408.48999"
    style="fill:url(#SVGID_00000080192896497866294550000002076154367824189827_)"
    y="71.089996"
    x="33.810001" />

  </g>
        <path
          id="path64"
          d="m 351.93,496.47 0.55,-0.12 1.7,-0.37 c 16.43,-3.56 31.81,-9.27 45.97,-16.78 l 1.64,-0.79 -0.03,-0.07 c 14.61,-7.93 27.93,-17.77 39.84,-29.16 -72.68,32.6 -127.89,25.02 -129.98,-59.6 V 290.9 c 0,-9.41 -3.02,-17.43 -9.18,-24.17 -12.31,-13 -32.25,-13 -44.57,0 -6.15,6.74 -9.16,14.76 -9.16,24.17 v 100.15 c -0.09,3.6 -0.09,7.12 0,10.52 v 1.82 h 0.05 c 1.66,46.84 20.2,75.07 47.8,88.49 16.25,7.87 34.7,8.93 55.37,4.59"
          class="st4"
          inkscape:connector-curvature="0"
          style="fill:#e50520" />
        <path
          id="path66"
          d="m 633.4,435.1 c -10.16,0 -17.95,-3.04 -23.37,-9.15 -5.43,-6.09 -8.14,-14.56 -8.14,-25.41 V 214.07 c 0,-23.03 10.5,-34.55 31.51,-34.55 21.34,0 32.01,11.52 32.01,34.55 v 186.47 c 0,10.84 -2.71,19.31 -8.14,25.41 -5.41,6.1 -13.37,9.15 -23.87,9.15"
          class="st4"
          inkscape:connector-curvature="0"
          style="fill:#e50520" />
        <path
          id="path68"
          d="m 746.24,435.61 c -21.68,0 -32.52,-10.84 -32.52,-32.52 V 211.03 c 0,-21.34 10.33,-32.02 30.99,-32.02 20.66,0 31,10.67 31,32.02 v 15.74 c 12.2,-29.13 38.27,-45.39 78.25,-48.77 14.57,-1.69 22.7,6.6 24.39,24.9 1.7,17.95 -7.11,27.94 -26.43,29.97 l -11.17,1.02 c -41.67,4.07 -62.5,25.41 -62.5,64.02 v 105.18 c 0,21.68 -10.67,32.52 -32.01,32.52"
          class="st4"
          inkscape:connector-curvature="0"
          style="fill:#e50520" />
        <path
          id="path70"
          d="m 927.68,435.61 c -21.68,0 -32.52,-10.84 -32.52,-32.52 V 211.03 c 0,-21.34 10.33,-32.02 30.99,-32.02 20.66,0 31,10.67 31,32.02 v 15.74 c 12.19,-29.13 38.27,-45.39 78.25,-48.77 14.56,-1.69 22.69,6.6 24.39,24.9 1.69,17.95 -7.11,27.94 -26.42,29.97 l -11.18,1.02 c -41.66,4.07 -62.5,25.41 -62.5,64.02 v 105.18 c 0,21.68 -10.67,32.52 -32.01,32.52"
          class="st4"
          inkscape:connector-curvature="0"
          style="fill:#e50520" />
        <path
          id="path72"
          d="m 1185.85,388.36 c 18.96,0 34.21,-6.86 45.72,-20.58 11.52,-13.72 17.28,-33.95 17.28,-60.71 0,-27.1 -5.76,-47.34 -17.28,-60.72 -11.52,-13.38 -26.76,-20.07 -45.72,-20.07 -18.97,0 -34.21,6.69 -45.73,20.07 -11.51,13.38 -17.27,33.62 -17.27,60.72 0,26.76 5.76,46.99 17.27,60.71 11.52,13.71 26.76,20.58 45.73,20.58 m 0,48.27 c -25.75,0 -48.1,-5.25 -67.07,-15.76 -18.97,-10.5 -33.7,-25.49 -44.21,-44.97 -10.5,-19.48 -15.75,-42.42 -15.75,-68.84 0,-26.42 5.25,-49.29 15.75,-68.59 10.5,-19.31 25.24,-34.22 44.21,-44.71 18.97,-10.5 41.32,-15.75 67.07,-15.75 25.74,0 48.1,5.25 67.07,15.75 18.97,10.5 33.7,25.4 44.2,44.71 10.5,19.3 15.76,42.17 15.76,68.59 0,26.42 -5.25,49.37 -15.76,68.84 -10.5,19.48 -25.23,34.46 -44.2,44.97 -18.97,10.51 -41.33,15.76 -67.07,15.76 z"
          class="st4"
          inkscape:connector-curvature="0"
          style="fill:#e50520" />
        <path
          id="path74"
          d="m 1472.97,388.36 c 18.97,0 34.22,-6.86 45.73,-20.58 11.52,-13.72 17.28,-33.95 17.28,-60.71 0,-27.1 -5.76,-47.34 -17.28,-60.72 -11.52,-13.38 -26.76,-20.07 -45.73,-20.07 -18.97,0 -34.21,6.69 -45.73,20.07 -11.51,13.38 -17.28,33.62 -17.28,60.72 0,26.76 5.76,46.99 17.28,60.71 11.52,13.71 26.76,20.58 45.73,20.58 m 17.79,48.27 c -18.29,0 -34.55,-3.99 -48.78,-11.95 -14.22,-7.96 -24.9,-18.71 -32.01,-32.26 v 10.67 c 0,21.68 -10.33,32.52 -30.99,32.52 -21,0 -31.51,-10.84 -31.51,-32.52 V 101.28 c 0,-21.34 10.51,-32.01 31.51,-32.01 21.34,0 32.01,10.67 32.01,32.01 v 118.38 c 7.46,-12.52 18.21,-22.61 32.27,-30.23 14.06,-7.62 29.89,-11.43 47.51,-11.43 22.02,0 41.16,5.25 57.41,15.75 16.26,10.5 28.96,25.32 38.11,44.46 9.15,19.14 13.72,42.09 13.72,68.85 0,26.42 -4.57,49.37 -13.72,68.84 -9.15,19.48 -21.93,34.46 -38.36,44.97 -16.44,10.51 -35.5,15.76 -57.17,15.76 z"
          class="st4"
          inkscape:connector-curvature="0"
          style="fill:#e50520" />
        <path
          id="path76"
          d="m 1729.61,392.93 c 16.6,0 30.41,-5.76 41.41,-17.28 11.01,-11.52 16.52,-26.08 16.52,-43.69 v -11.18 h -17.28 c -31.84,0 -53.94,2.45 -66.31,7.36 -12.37,4.91 -18.55,13.81 -18.55,26.67 0,11.18 3.89,20.33 11.68,27.44 7.81,7.12 18.65,10.68 32.53,10.68 m -13.21,43.7 c -17.95,0 -33.95,-3.48 -48.02,-10.42 -14.05,-6.94 -25.06,-16.35 -33.02,-28.2 -7.96,-11.85 -11.94,-25.23 -11.94,-40.14 0,-18.29 4.74,-32.77 14.22,-43.44 9.49,-10.67 24.9,-18.37 46.24,-23.12 21.34,-4.74 49.96,-7.11 85.87,-7.11 h 17.78 v -10.67 c 0,-16.94 -3.73,-29.13 -11.18,-36.58 -7.46,-7.45 -19.99,-11.18 -37.6,-11.18 -9.82,0 -20.41,1.19 -31.76,3.56 -11.35,2.37 -23.29,6.44 -35.82,12.2 -8.13,3.72 -14.9,4.15 -20.33,1.27 -5.42,-2.87 -9.06,-7.45 -10.92,-13.72 -1.86,-6.26 -1.52,-12.61 1.02,-19.05 2.54,-6.43 7.71,-11.17 15.5,-14.22 15.59,-6.44 30.58,-11.02 44.97,-13.72 14.4,-2.71 27.53,-4.06 39.38,-4.06 36.24,0 63.17,8.38 80.79,25.15 17.61,16.77 26.42,42.77 26.42,77.99 v 121.95 c 0,21.68 -9.82,32.52 -29.47,32.52 -19.98,0 -29.97,-10.84 -29.97,-32.52 v -11.18 c -5.76,13.89 -14.9,24.81 -27.44,32.77 -12.54,7.93 -27.44,11.92 -44.72,11.92 z"
          class="st4"
          inkscape:connector-curvature="0"
          style="fill:#e50520" />
      </g>
    </g>
  </svg>
</template>
<style
id="style10"
type="text/css">
.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E50520;}
.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#E3022B;}

.st2{clip-path:url(#SVGID_00000153696503271648898500000000760289002376897169_);fill:url(#SVGID_00000091718318370771947210000002134235428678848643_);}

.st3{clip-path:url(#SVGID_00000063635214559325421480000010497399917208663981_);fill:url(#SVGID_00000103959988499832184000000003978596928837723315_);}
.st4{fill:#E50520;}
</style>

<script>
export default {
  name: "IrrobaSvg",
  props: ["width", "height"]
}
</script>